exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "#pufferfish .sticky-component.sticky{position:fixed}", ""]);
